// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605070803/js/" + chunkId + "." + {"44":"8aa8243a","225":"9c5b3407","481":"b32cb123","486":"f27770f9","770":"b7ba574a"}[chunkId] + ".0.6658550034486543.chunk.js";
};